export default {
  name: "Knowledge"
};